import React from 'react';
import { PublicShell } from './PublicShell';
import { Landing } from '../../pages/public/Landing';
import { LandingB } from '../../pages/public/LandingB';
import { DesignVariantSwitch } from '../experience/DesignVariantSwitch';

/**
 * The homepage.
 *
 * Two approved designs of one homepage over one set of data. Which one is
 * presented is configuration an administrator publishes, resolved by the
 * shared design variant controller — this file only says what each design is.
 *
 * The two are structured differently, so a handover returns to the top rather
 * than stranding a reader in the middle of a section that no longer exists.
 */
export function HomepageExperience() {
  return <DesignVariantSwitch surface="HOME" scrollToTopOnChange render={design => design === 'DESIGN_2' ? <LandingB data-id="element-4670" data-mp="2vj1p7m9ty0n6" /> : <div data-campuzon-experience="design-a" data-id="element-4671" data-mp="2vi05yuinu7ud">
            <PublicShell data-id="element-4672" data-mp="2qk6wnsm28xpv">
              <Landing data-id="element-4673" data-mp="2qkzziihwf32q" />
            </PublicShell>
          </div>} data-id="element-4669" data-mp="3j9dwqw15xvd8" />;
}